<template>
    <q-select
        outlined
        :modelValue="modelValue"
        :label="label"
        @update:modelValue="$emit('update:modelValue', $event)"
        :options="options"
        :error="error"
        :loading="loading"
        :disable="loading"
    >
        <template v-slot:no-option>
            <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
        </template>
        <template v-slot:error>
            <span v-for="err in errors" :key="err">{{ err }}</span>
        </template>
        <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope || {}" />
        </template>
    </q-select>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import HelperListService from "@/services/HelperListService";
const props = defineProps({
    modelValue: [String, Number, Object],
    errors: [String, Array],
    label: [String],
});
defineEmits(["update:modelValue"]);
const options = ref([]);
let defaultOptions = [];
const error = computed(() => props.errors && props?.errors?.length !== 0);
const loading = ref(false);

onMounted(async () => {
    loading.value = true;
    defaultOptions = await HelperListService.grupoProductosWeb();
    options.value = defaultOptions;
    loading.value = false;
});
</script>
